import { render, staticRenderFns } from "./SortIndicator.vue?vue&type=template&id=b2d54172&"
import script from "./SortIndicator.vue?vue&type=script&lang=js&"
export * from "./SortIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports